module.exports = __webpack_public_path__ + "static/media/DummyAkt.fd804040.jpg";